import { createSlice } from "@reduxjs/toolkit";

const supported = ["tr", "en", "de", "fr"];

const getBrowserLang = () => {
  const navLang = (navigator.language || "tr").toLowerCase(); // "tr-TR"
  const short = navLang.split("-")[0]; // "tr"
  return supported.includes(short) ? short : "tr";
};

const initialState = {
  languages: [
    { code: "fr", name: "FR" },
    { code: "en", name: "EN" },
    { code: "tr", name: "TR" },
    { code: "de", name: "DE" },
  ],
  language: getBrowserLang(), 
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    switchLanguage(state, action) {
      state.language = action.payload;
    },
  },
});

export const { switchLanguage } = languageSlice.actions;
export default languageSlice.reducer;
